import React from 'react';
import './WhatsAppFloat.css';

const WHATSAPP_NUMBER = '916355592849'; // country code + number, no + or spaces
const DEFAULT_MESSAGE = 'Hey Fcreation, I want to inquire about the gifting.';

const WhatsAppFloat = () => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float-btn"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="wa-float-btn__text">Chat with us</span>
      <span className="wa-float-btn__icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12.001 2C6.478 2 2 6.478 2 12c0 1.892.526 3.66 1.438 5.168L2 22l4.958-1.412A9.953 9.953 0 0 0 12.001 22C17.523 22 22 17.523 22 12S17.523 2 12.001 2zm0 18.163a8.14 8.14 0 0 1-4.148-1.133l-.298-.177-3.087.879.883-3.007-.194-.309a8.14 8.14 0 0 1-1.259-4.372c0-4.501 3.663-8.163 8.163-8.163S20.163 7.5 20.163 12.001c0 4.5-3.662 8.162-8.162 8.162z"/>
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
